import { createSelector } from 'reselect';

const selectGlobalParsingRules = (state: any) => state.globalParsingRules;


export const selectglobalParsingRulesCurrentItem = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.current);

export const selectglobalParsingRulesListItems = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.list);

export const selectglobalParsingRulesItemById = (itemId: any) =>
    createSelector(selectglobalParsingRulesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectglobalParsingRulesQueryItems = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.query);

export const selectglobalParsingRulesCreatedItem = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.create);

export const selectglobalParsingRulesUpdatedItem = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.update);

export const selectglobalParsingRulesReadItem = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.read);

export const selectglobalParsingRulesDeletedItem = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.delete);

export const selectglobalParsingRulesSearchedItems = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.search);

export const selectglobalParsingRulesItemsCount = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.count);

export const selectglobalParsingRulesItemsFilter = createSelector([selectGlobalParsingRules], (globalParsingRules) => globalParsingRules.filter);